import { checkGate, getExperiment } from '@eventbrite/statsig';
import {
    TrustMessageText,
    TRUST_MESSAGE_EXPERIMENT,
} from '../constants/statsig';

export const checkCardImprovementsFeatureGate = () => {
    const value = checkGate('checkout_card_improvements');
    return value === 'false' ? false : value;
};

export const getTrustMessageExperimentValue = () =>
    getExperiment(
        TRUST_MESSAGE_EXPERIMENT.name,
        TRUST_MESSAGE_EXPERIMENT.param,
        TRUST_MESSAGE_EXPERIMENT.defaultValue,
    );

export const isNoMessageVariant = () =>
    getTrustMessageExperimentValue() === TrustMessageText.NO_MESSAGE;

export const isTransactionSafeVariant = () =>
    getTrustMessageExperimentValue() ===
    TrustMessageText.VARIANT_TRANSACTION_SAFE;
